import cookie from 'react-cookies'

export class cookies {
  static get = (name: string) => cookie.load(name)
  static set = (name: string, data: string, expires: Date) => {
    cookie.save(name, data, {
      path: '/',
      expires,
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    })
  }
  static removeAll = () => {
    cookie.remove('next-auth.session-token', '', {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      secure: true,
    })
    cookie.remove('next-auth.session-token', {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      secure: true,
    })
    cookie.save('__Secure-next-auth.session-token', '', {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      secure: true,
    })
    cookie.remove('__Secure-next-auth.session-token', {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      secure: true,
    })
    cookie.remove('refresh', {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    })
    cookie.remove('access', {
      path: '/',
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    })
    const cookies = cookie.loadAll()
    Object.keys(cookies).map(key =>
      cookie.remove(key, {
        path: '/',
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
      })
    )
  }
}
